<template>
  <router-link v-a11y-tab:tab-line :to="referralPath">
    <a-button
      :loading="privateInfoLoading"
      type="primary"
      class="button-container referral-button"
    >{{ buttonText }}</a-button>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex';
import { ROUTER_PATHS } from '@/router/constants';

export default {
  data() {
    return {
      referralPath: ROUTER_PATHS.REFERRALS,
    };
  },
  computed: {
    ...mapGetters(['referralReward', 'privateInfoLoading']),

    buttonText() {
      return this.privateInfoLoading
        ? this.$t('calculating.reward')
        : this.$t('refer.friend', { reward: this.referralReward });
    },
  },
};
</script>

<style lang="scss" scoped>
.referral-button.ant-btn {
  margin: 0 !important;
}
</style>